<mat-tab-group [(selectedIndex)]="tabIndex" (selectedTabChange)="tabChanged($event)">
    <mat-tab *ngFor="let page of subpages" [label]="page.label" >

      <form [formGroup]="regionForm" >
        <ng-container *ngIf="page.availableRegions.length > 1">
          <mat-form-field appearance="fill">
            <mat-label>Region</mat-label>
            <mat-select [formControl]="regionControl" (selectionChange)="selectRegion()">
              <mat-option [value]="region" *ngFor="let region of page.availableRegions"> {{ region.name }} </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </form>


      <ng-container *ngIf="page.availableRegions.length == 1">
        <div  class="regionLabel">
          <mat-label>Region: {{page.availableRegions[0].name}}</mat-label>
        </div>
      </ng-container>

      <mat-progress-bar class="centerBar" *ngIf="iFrameLoading" mode="buffer"></mat-progress-bar>
      <iframe (load)="iFrameLoaded()" *ngIf="!page.availableRegions" [style.height.px]="iframeHeight" class="StatusContainer" [src]="page.statusPageUrl | safe"></iframe>
      <iframe (load)="iFrameLoaded()" *ngIf="page.availableRegions" [style.height.px]="iframeHeight" class="StatusContainer" [src]="regionControl.value.statusPageUrl | safe"></iframe>

    </mat-tab>
</mat-tab-group>

